import { cx } from "@/utils";
import AllEarsTitle from "@components/AllEarsTitle";
import IconBall, { IconBallProps } from "@components/IconBall";
import Typography from "@components/Typography";

import styles from "./StatusPages.module.css";

export type StatusPageProps = {
  children?: React.ReactNode;
  title: string;
  subtitle?: string;
} & React.HTMLProps<HTMLDivElement> &
  Pick<IconBallProps, "icon">;

const StatusPage: React.FunctionComponent<StatusPageProps> = ({
  children,
  className,
  icon,
  title,
  subtitle,
  ...props
}) => {
  return (
    <>
      <AllEarsTitle title={title} />
      <div {...props} className={cx(styles.root, className)}>
        <IconBall icon={icon} />
        <Typography align="center" variant="h1">
          {title}
        </Typography>
        {subtitle && (
          <Typography align="center" variant="h5">
            {subtitle}
          </Typography>
        )}
        {children}
      </div>
    </>
  );
};

export default StatusPage;
